import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { Observable } from 'rxjs';

export interface NewsletterPayload {
    subscriberEmail: string;
}

export interface NewsletterResponse {
    code: number;
    message: string;
}

@Injectable({
    providedIn: 'root',
})
export class NewsletterService {
    constructor(private _apiService: ApiService) {}

    submitNewsletter(payload: NewsletterPayload): Observable<any> {
        return this._apiService.post(API_ENDPOINTS.NEWSLETTER, payload);
    }
}
